module.exports = __webpack_public_path__ + "static/img/wa-offshore-colorbar.46bebbc.png";